import React from "react";

import { CUSTOM_PAGE_OPTIONS } from "../pageKinds";
import BoardSectionsInspector from "./BoardSectionsInspector";

/**
 * LE CONTENU D'UNE PAGE CUSTOM : le choix du composant, puis les sections de
 * graphes qu'on lui ajoute en bas de page.
 *
 * La liste est fermée et vient du registre (customPages.js) — on ne saisit pas
 * un identifiant à la main. Un `component_id` qui ne résout pas produirait un
 * écran de repli en pleine séance ; le seul moyen sûr de ne pas en écrire un
 * est de ne jamais l'offrir.
 *
 * Une page déjà en base peut pourtant nommer un composant retiré du registre :
 * on l'affiche alors comme une option barrée plutôt que de faire disparaître
 * silencieusement le réglage de l'écran.
 */
export default function CustomContentInspector({ page, onPatchContent, ctx }) {
  const current = page.content?.component_id || "";
  const known = CUSTOM_PAGE_OPTIONS.some((o) => o.id === current);

  return (
    <div className="custom-page-options">
      {!known && current && (
        <p className="builder-warning-inline">
          Cette page demande le composant <code>{current}</code>, absent du
          registre des écrans custom. Choisissez-en un autre, ou remettez
          l'entrée dans <code>customPages.js</code>.
        </p>
      )}
      {CUSTOM_PAGE_OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          className={`custom-page-option${current === option.id ? " is-active" : ""}`}
          onClick={() => onPatchContent({ component_id: option.id })}
          aria-pressed={current === option.id}
        >
          <span className="custom-page-option-icon" aria-hidden="true">{option.icon}</span>
          <span className="custom-page-option-body">
            <span className="custom-page-option-label">{option.label}</span>
            <span className="custom-page-option-hint">{option.hint}</span>
            <code className="custom-page-option-id">{option.id}</code>
          </span>
        </button>
      ))}
      {known && <BoardSectionsInspector page={page} onPatchContent={onPatchContent} ctx={ctx} />}
    </div>
  );
}
